<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>
        Områder
      </v-toolbar-title>
      <v-spacer />
      <v-text-field
        v-model="search"
        solo
        hide-details
        dense
        clearable
        class="mr-3"
        append-icon="mdi-magnify"
      />
      <v-spacer />
      <v-menu
        v-model="addMenu"
        left
        :close-on-content-click="false"
        min-width="500"
      >
        <template #activator="{ attrs, on }">
          <v-btn
            v-bind="attrs"
            v-on="on"
          >
            Nyt område
            <v-icon right> mdi-plus </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            Nyt område
          </v-card-title>
          <v-card-text>
            <v-form
              ref="addForm"
              v-model="valid"
            >
              <v-text-field
                v-model="newItem.name"
                label="Navn"
                autofocus
                :rules="[ v => !!v || $t('common.requiredField') ]"
                outlined
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="onCloseAddMenu"
            >
              {{ $t('common.cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!valid"
              :loading="creating"
              @click="create"
            >
              Opret
              <v-icon right> mdi-plus </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-data-table
      :items="types"
      :headers="headers"
      :loading="loading"
      :search="search"
    >
      <template #[`item.actions`]="{ item }">
        <v-btn small @click="onEditItem(item)">
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
      v-model="editDialog"
      width="800"
    >
      <v-card>
        <v-card-title>
          Rediger
        </v-card-title>
        <v-card-text>
          <v-form
            v-if="editItem"
            ref="editForm"
            v-model="editForm"
          >
            <v-text-field
              v-model="editItem.name"
              label="Navn"
              autofocus
              :rules="[ v => !!v || 'Udfyld et navn' ]"
              outlined
              clearable
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />

          <v-btn :loading="saving" @click="saveItem">
            {{ $t('common.save') }}
            <v-icon right> mdi-content-save-outline </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const baseUrl = 'location-areas';

export default {
  name: 'CustomerLocationAreasComponent',
  data() {
    return {
      creating: false,
      loading: true,
      newItem: {},
      addMenu: false,
      saving: false,
      search: '',
      valid: false,
      editItem: null,
      editForm: false,
      editDialog: false,
      types: [],
      headers: [
        { text: 'Navn', value: 'name', width: '50%' },
        { text: 'Lokationer', value: 'locationsCount' },
        { text: 'Actions', value: 'actions', align: 'right', sortable: false }
      ],
    }
  },
  mounted() {
    this.getItems();
  },
  watch: {
    editDialog(value) {
      if (!value) {
        this.editItem = null;
      }
    }
  },
  methods: {
    create: async function() {
      this.creating = true;

      try {
        const model = {
          ...this.newItem,
          customerId: this.$route.params.customerId
        };

        const { data } = await this.$api.post(baseUrl, model);

        if (!data.success) throw data.errors?.at(0)?.message ?? data.message ?? 'Something went wrong';

        this.$notifier.showSuccess({ message: 'Område oprettet' });
        this.getItems();
        this.onCloseAddMenu();
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.creating = false;
      }
    },
    onEditItem: function(item) {
      this.editItem = JSON.parse(JSON.stringify(item));
      this.editDialog = true;
    },
    getItems: async function() {
      this.loading = true;

      try {
        const { data } = await this.$api.get(baseUrl, {
          params: {
            customerId: this.$route.params.customerId
          }
        });

        this.types = data;
        this.$emit('loaded', data);
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.loading = false;
      }
    },
    saveItem: async function() {      
      this.saving = true;

      const { name } = this.editItem;

      const model = {
        name
      };

      try {
        const { data } = await this.$api.patch(`${baseUrl}/${this.editItem.id}`, model);

        if (!data.success) throw data.errors?.at(0)?.message ?? data.message ?? 'Something went wrong';

        this.$notifier.showSuccess({ message: 'Område opdateret' });
        this.getItems();
        this.editDialog = false;
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.saving = false;
      }
    },
    onCloseAddMenu() {
      this.$refs.addForm.reset();
      this.addMenu = false;
    }
  }
}
</script>